import React, { useEffect, useState } from "react";
import logo from "assets/layout_img/logo.png";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const [hidden, setHidden] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScroll && currentScroll > 100) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      setLastScroll(currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []); // ✅ Dependency olib tashlandi

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    setMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
      return;
    }

    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleLogoClick = () => {
    setMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/");
      return;
    }

    const homeElement = document.getElementById("home");
    if (homeElement) {
      homeElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className={`navbar ${hidden ? "navbar--hidden" : ""}`}>
      <img
        src={logo}
        alt="Logo"
        onClick={handleLogoClick}
        className="cursor-pointer"
      />

      <ul className={`navbar_list ${menuOpen ? "active" : ""}`}>
        <li>
          <a
            className="navbar_links"
            href="#home"
            onClick={(e) => handleLinkClick(e, "#home")}
          >
            Bosh sahifa
          </a>
        </li>
        <li>
          <a
            className="navbar_links"
            href="#about"
            onClick={(e) => handleLinkClick(e, "#about")}
          >
            Biz haqimizda
          </a>
        </li>
        <li>
          <a
            className="navbar_links"
            href="#teachers"
            onClick={(e) => handleLinkClick(e, "#teachers")}
          >
            O'qituvchilar
          </a>
        </li>
        <li>
          <a
            className="navbar_links"
            href="#events"
            onClick={(e) => handleLinkClick(e, "#events")}
          >
            Tadbirlar
          </a>
        </li>
        <li>
          <a
            className="navbar_links"
            href="#comments"
            onClick={(e) => handleLinkClick(e, "#comments")}
          >
            Fikrlar
          </a>
        </li>
        <li>
          <button
            className="home_btn"
            onClick={() => {
              setMenuOpen(false);
              navigate("/login");
            }}
          >
            Login
          </button>
        </li>
      </ul>

      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={toggleMenu}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
    </nav>
  );
};

export default Navbar;
